import UnorderedList from '@/components/modals/InputMapping/partials/sectionInfoTypes/UnorderedList/UnorderedList.vue';
import { SIMPLE_CHOICE } from '@/features/ChoicesLists/Simple/types';
import type { InputMappingGroup } from '@/features/InputMapping/types';
import { getLocaleDateString } from '@/utils/dates/dates';
import boolean from '@/utils/formatters/boolean';
import { formatCurrency } from '@/utils/formatters/euro';
import { formatChoice } from '@/utils/formatters/simpleChoice';

export const absicherungsGroupMapping: InputMappingGroup = {
  icon: 'shield-alt',
  label: 'Gewünschte Absicherung',
  infos: [
    {
      component: UnorderedList,
      props: {
        fields: [
          {
            path: 'versicherungsbeginn',
            formatter: getLocaleDateString,
          },
          {
            path: 'zahlweise',
            formatter: formatChoice(SIMPLE_CHOICE.PAYMENT_PERIOD),
          },
          {
            path: 'versicherungssumme',
            formatter: formatCurrency,
          },
          {
            label: 'Vorversicherung',
            path: 'vorversicherung',
            formatter: formatChoice(SIMPLE_CHOICE.VORVERSICHERUNG),
          },
          {
            path: 'fahrraddiebstahl',
            formatter: formatChoice(SIMPLE_CHOICE.FAHRRADDIEBSTAHL),
          },
          {
            path: 'fahrradsumme',
            formatter: formatCurrency,
          },
          {
            path: 'selbstbeteiligung',
            formatter: formatChoice(SIMPLE_CHOICE.SELBSTBETEILIGUNG),
          },
          {
            path: 'laufzeit',
            formatter: formatChoice(SIMPLE_CHOICE.LAUFZEIT),
          },
          {
            path: 'elementarversicherung',
            formatter: boolean,
          },
          {
            path: 'glasversicherung',
            formatter: boolean,
          },
        ],
      },

      requiredPaths: [
        'zahlweise',
        'versicherungsbeginn',
        'versicherungssumme',
        'vorversicherung',
        'fahrraddiebstahl',
        'fahrradsumme',
        'selbstbeteiligung',
        'laufzeit',
        'elementarversicherung',
        'glasversicherung',
      ],
      requiredOr: true,
    },
  ],
};
